// ======================================================================
// 📁 File: src/modules/ticket/forms/CustomFieldInput.jsx
// 🎨 Premium Dynamic Input Renderer with Floating Labels + i18n
// ⭐ FINAL FIXED VERSION (2025-12-01)
// ======================================================================

import React from "react";
import { useTranslation } from "react-i18next";

export default function CustomFieldInput({ field, value, onChange }) {
  const { t } = useTranslation();

  // Backend always sends field.field_type
  const type = field.field_type;

  const handleChange = (e) => {
    const val = type === "checkbox" ? e.target.checked : e.target.value;
    onChange(field.id, val);
  };

  const val = value === undefined || value === null ? "" : value;

  const FloatingWrapper = ({ children }) => (
    <div className="floating-label-group mb-4">{children}</div>
  );

  // text
  if (type === "text")
    return (
      <FloatingWrapper>
        <input
          type="text"
          className="form-control"
          placeholder=" "
          value={val}
          onChange={handleChange}
        />
        <label className="floating-label">{t(field.label)}</label>
      </FloatingWrapper>
    );

  // number
  if (type === "number")
    return (
      <FloatingWrapper>
        <input
          type="number"
          className="form-control"
          placeholder=" "
          value={val}
          onChange={handleChange}
        />
        <label className="floating-label">{t(field.label)}</label>
      </FloatingWrapper>
    );

  // select dropdown
  if (type === "select")
    return (
      <FloatingWrapper>
        <select className="form-select" value={val} onChange={handleChange}>
          <option value=""></option>
          {field.options?.map((opt, i) => (
            <option key={i} value={opt.value}>
              {t(opt.label)}
            </option>
          ))}
        </select>
        <label className="floating-label">{t(field.label)}</label>
      </FloatingWrapper>
    );

  return <p className="text-danger">⚠ Unknown field type: {type}</p>;
}
    